import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent19 } from "./VipGameCommissionCRUD";
import { vipGameCommissionSlice } from "./VipGameCommissionSlice";

const { actions } = vipGameCommissionSlice;

export const clearVipGameCommissionList = () => (dispatch) => {
  dispatch(actions.vipGameCommissionListFetched({ data: null }));
};

export const fetchVipGameCommissionUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent19(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipGameCommissionUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipGameCommissionUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipGameCommissionList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent19(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.vipGameCommissionListFetched({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipGameCommissionList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipGameCommissionEffList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent19(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.vipGameCommissionEffListFetched({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipGameCommissionEffList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const publishVipGameCommission = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent19(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipGameCommissionPublished());
          return response;
        }
      } else {
        throw new Error("Error api: publishVipGameCommission");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
